export enum Language {
    ENGLISH = 'English',
    UKRAINE = 'Ukraine'
}
